document.addEventListener('alpine:init', () => {
  Alpine.data('Theme_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener('baseline:cart:afteradditem', () => {
            Alpine.store('modals').closeAll();

            Alpine.store('modals').open('cart');
          });
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
        
        // Expand drawer width when upsell sidebar is present
        this.$watch('$store.modals.rightDrawer.contents', (contents) => {
          if (contents === 'cart') {
            const drawerSlot = document.getElementById('right-drawer-slot');
            const sidebar = drawerSlot?.querySelector('[data-has-upsell-sidebar]');
            if (drawerSlot) {
              if (sidebar) {
                drawerSlot.setAttribute('data-has-upsell-sidebar', 'true');
              } else {
                drawerSlot.removeAttribute('data-has-upsell-sidebar');
              }
            }
          }
        });
      },
    };
  });
});
